import axiosInstance from "../../../../lib/axiosInstance";

// Public community endpoints — unauthenticated, moderated server-side.
// See vecros-api/docs/FRONTEND-REQUESTS.md ("Public part submissions & reports").

const detail = (error, fallback) => {
  // A 404 means the endpoint isn't deployed yet — the server's literal
  // "Not Found" would just confuse; use the friendly fallback.
  if (error?.response?.status === 404) return fallback;
  const d = error?.response?.data?.detail;
  if (!d) return fallback;
  return typeof d === "string" ? d : JSON.stringify(d);
};

/** Request a part (motor/propeller/esc/battery/drone) be added to the public catalog. */
export const submitPartRequest = async ({ type, payload, contact_email, notes }) => {
  try {
    const { data } = await axiosInstance.post("/propulsion/public/submissions", {
      // The API field is `part_type`; sending `type` 422s every submission.
      part_type: type,
      payload,
      contact_email: contact_email || undefined,
      notes: notes || undefined,
    });
    return data; // { submission_id, status: "pending" }
  } catch (error) {
    throw new Error(detail(error, "Could not submit right now — please try again later."));
  }
};

/** Report wrong/duplicate/spam data in the public catalog. */
export const reportData = async ({ reason, subject, details }) => {
  try {
    const { data } = await axiosInstance.post("/propulsion/public/reports", {
      reason,
      subject: subject || undefined,
      details: details || undefined,
    });
    return data; // { report_id }
  } catch (error) {
    throw new Error(detail(error, "Could not send the report right now — please try again later."));
  }
};
